module.exports = __webpack_public_path__ + "img/beautify7.3e084cb4.webp";